import { CheckCircle, CircleNotch, WarningCircle, Circle, X } from "@phosphor-icons/react";

const STEPS = [
  { key: "understanding", label: "Compréhension de la demande" },
  { key: "signals", label: "Analyse des signaux marché" },
  { key: "context", label: "Contexte de recherche" },
  { key: "done", label: "Résultats" },
];

function stepState(key, events, status) {
  const evs = events.filter((e) => e.stage === key);
  const idx = STEPS.findIndex((s) => s.key === key);
  const reached = events.some((e) => STEPS.findIndex((s) => s.key === e.stage) > idx);
  if (evs.some((e) => e.level === "error")) return "error";
  if (evs.some((e) => e.level === "success") || reached) return "done";
  if (evs.length) return status === "error" ? "error" : "active";
  return "pending";
}

const ICONS = {
  done: <CheckCircle size={16} weight="fill" className="text-accent" />,
  active: <CircleNotch size={16} className="text-accent animate-spin" />,
  error: <WarningCircle size={16} weight="fill" className="text-destructive" />,
  pending: <Circle size={16} className="text-muted/50" />,
};

export const MissionProgress = ({ mission, onCancel }) => {
  const events = mission?.events || [];
  const status = mission?.status || "pending";
  return (
    <div className="surface rounded-lg p-5 mb-4" data-testid="mission-progress">
      <div className="flex items-center justify-between mb-4">
        <div className="overline">Mission de recherche en cours</div>
        {onCancel && (
          <button onClick={onCancel} data-testid="mission-cancel-btn"
            className="flex items-center gap-1.5 text-xs text-muted hover:text-fg border border-border rounded-md px-2.5 py-1 transition-colors">
            <X size={12} /> Annuler
          </button>
        )}
      </div>
      <ol className="grid sm:grid-cols-4 gap-3">
        {STEPS.map((s) => {
          const st = stepState(s.key, events, status);
          const last = [...events].reverse().find((e) => e.stage === s.key);
          return (
            <li key={s.key} data-testid={`mission-step-${s.key}`} data-state={st}
              className={`rounded-md border p-3 transition-colors duration-300 ${st === "active" ? "border-accent/40 bg-accent/[0.06]" : "border-border bg-surface-2/40"}`}>
              <div className="flex items-center gap-2 text-sm font-medium text-fg">{ICONS[st]} {s.label}</div>
              {last?.message && st !== "pending" && (
                <p className="text-[11px] text-muted mt-1.5 line-clamp-2" data-testid={`mission-step-${s.key}-message`}>{last.message}</p>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
